import React from 'react';
import hard1 from '../../../../assets/img/movil/hardware.jpg';
import hard2 from '../../../../assets/img/movil/Nuestros_Partners.jpg';
import './CMHardware.css';

function CMHardware() {

    return (
        <div id="CMHardware">
            <section id="Hard__head">
                <h2>Distribución de Hardware</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Distribución de Hardware</li>
                </ul>
            </section>
            <section id="Hard__section2">
                <figure id="Hard-content">
                    <img src={hard1} />
                </figure>
                <div id="Hard-text">
                    <p id="Hard-text__p1">En <strong>INFRASOL</strong> somos distribuidores oficiales de las <strong>mejores</strong> marcas.</p>
                    <p id="Hard-text__p2">Ofrecemos soluciones confiables, de alto rendimiento y con garantía certificada. Proveemos equipamiento tecnológico de calidad empresarial, incluyendo servidores, estaciones de trabajo, equipos de usuario final, periféricos y suministros, adaptados a las necesidades operativas y presupuestales de cada organización.</p>
                </div>
            </section>
            <section id="Hard__section3">
                <div id="Hards3-content1">
                    <h2>Hardware alineado a los <strong>tiempos actuales.</strong></h2>
                    <p>La evolución constante de las empresas exige la renovación periódica de los parques informáticos y de los sistemas de comunicación. En INFRASOL analizamos y evaluamos soluciones de hardware, software y metodologías de trabajo para asesorar a nuestros clientes en la adopción de tecnologías confiables y contrastadas, compatibles con su infraestructura actual, escalables para el crecimiento futuro y acordes a las demandas tecnológicas actuales.</p>
                </div>
                <div id="Hards3-content2">
                    <figure>
                        <img src={hard2} />
                    </figure>
                    <p><strong>¿Necesitas una cotización?</strong> Para cualquier solicitud de cotización o asesoría, contáctanos a través del botón de WhatsApp o mediante el menú Contacto.</p>
                </div>
            </section>
        </div>
    );
}

export default CMHardware;